export default __webpack_public_path__ + "static/media/Boxing_08.bd497cae.png";